import { Auth } from 'aws-amplify';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useBoolean } from 'react-use';
import { useFlashMessages } from 'domains/flash-messages';
import { ResetPasswordForm, ResetPasswordFormData } from 'domains/auth/PasswordReset/ResetPasswordForm';
import {
  RequestResetPasswordForm,
  RequestResetPasswordFormData,
} from 'domains/auth/PasswordReset/RequestResetPasswordForm';
import { PageContainer } from '@expressable/syntax-ds';

export const PasswordReset = (): JSX.Element => {
  const [email, setEmail] = useState<string | null>(null);
  const [loading, setLoading] = useBoolean(false);

  const { showFlash, clearFlash } = useFlashMessages();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onSubmitEmail = (data: RequestResetPasswordFormData) => {
    setEmail(data.username);
    return Auth.forgotPassword(data.username);
  };

  const onSubmitReset = ({ code, password }: ResetPasswordFormData) => {
    setLoading(true);
    clearFlash();

    if (email) {
      return Auth.forgotPasswordSubmit(email, code, password)
        .then(() => {
          navigate('/');
        })
        .catch(() =>
          showFlash([
            {
              variant: 'error',
              message: t('login.passwordReset.error'),
              key: 'form-feedback',
            },
          ]),
        )
        .finally(() => setLoading(false));
    }
    return false;
  };

  return (
    <>
      <PageContainer variant="small-form" className="mt-[0px] mb-[0px]">
        {email === null && <RequestResetPasswordForm onSubmit={onSubmitEmail} loading={loading} />}
        {email && <ResetPasswordForm onSubmit={onSubmitReset} loading={loading} />}
      </PageContainer>
    </>
  );
};
